export const getNameInitials = (
  firstName: string,
  lastName?: string,
): string => {
  const firstInitial = firstName?.[0]?.toUpperCase() ?? '';
  const lastInitial = lastName?.[0]?.toUpperCase() ?? '';
  return `${firstInitial}${lastInitial}`;
};

/**
 * Gets initials from a full name
 * @param name - The full name
 * @returns The initials
 */
export const getInitialsFromFullName = (name: string): string => {
  if (!name || typeof name !== 'string') return '';

  const words = name.trim().split(/\s+/);

  if (words.length === 1) {
    // Single word - use existing utility with empty lastName
    return getNameInitials(words[0]);
  }

  // Multiple words - use first and last word
  const firstName = words[0];
  const lastName = words[words.length - 1];

  return getNameInitials(firstName, lastName);
};
